import { render, staticRenderFns } from "./edc-form-info-new.vue?vue&type=template&id=dc642fb4&scoped=true&"
import script from "./edc-form-info-new.vue?vue&type=script&lang=js&"
export * from "./edc-form-info-new.vue?vue&type=script&lang=js&"
import style0 from "./edc-form-info-new.vue?vue&type=style&index=0&id=dc642fb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc642fb4",
  null
  
)

component.options.__file = "edc-form-info-new.vue"
export default component.exports